module.exports = __webpack_public_path__ + "img/SHELLS.5e29ce11.png";